import React from 'react';
import { render } from 'react-dom';
import App from './components/App';
import './sass/styles.scss';

render(<App />, document.querySelector('#main'));